package pwgs.ui.scenes.customstatscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class ACustomStatControllerFe(props: pwgs.ui.scenes.customstatscene.CustomStatSceneProps, scene: MCustomStatScene)
 : AController<pwgs.ui.scenes.customstatscene.CustomStatSceneProps, pwgs.ui.scenes.customstatscene.CustomStatSceneModel, CustomStatSceneState>(props, scene) {

    val backend = CustomStatControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    fun call_refreshTodayStat() {
        launchOnDefaultControllerScope {
            render(backend.refreshTodayStat())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class CustomStatControllerBeProxy(private val controller: ACustomStatControllerFe) {

    suspend fun load(): pwgs.ui.scenes.customstatscene.CustomStatSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.customstatscene.CustomStatControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.customstatscene.CustomStatSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.customstatscene.CustomStatSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.customstatscene.CustomStatSceneModel.serializer())
        }
    }

    suspend fun refreshTodayStat(): pwgs.ui.scenes.customstatscene.CustomStatSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.customstatscene.CustomStatControllerBe.refreshTodayStat",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.customstatscene.CustomStatSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.customstatscene.CustomStatSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.customstatscene.CustomStatSceneModel.serializer())
        }
    }

}
